import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/user-add',
      name: 'admin-user-add',
      component: () => import(/* webpackChunkName: "page-admin-system-management-user-add" */ `./1.0.0/index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "添加员工"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "系统管理"
                                        },
                                        {
                                                  name: "添加员工"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
